<template>
  <div class="to-app-area">
    <AlertBox
      class="to-app-area__alert-box"
      title="現在Web版のページが表示されています"
    >
      <div class="btn-multi-expand__contents">
        <div class="to-app-area__contents btn-multi-expand__explanation">
          <p>
            <slot />
          </p>
        </div>
      </div>
    </AlertBox>
    <ButtonPrimary text="giftee アプリに戻る" @click="onClickAppButton" />
  </div>
</template>

<script>
import AlertBox from '../../molecules/alert_box/AlertBox.vue'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'

export default {
  components: { ButtonPrimary, AlertBox },
  methods: {
    onClickAppButton() {
      this.$emit('click-app-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.to-app-area {
  max-width: 343px;
  margin: 0 auto 40px auto;

  &__alert-box {
    margin-bottom: 32px;
  }

  &__contents {
    padding: 0;
  }
}
</style>
